import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CustomizationFrameworkService } from '../customization-framework.service';
import { CSTField, CustomFieldDataObject } from '../models/custom-data-field.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { skip, timestamp } from 'rxjs/operators';
import { CustomFieldControlTypeEnum } from '../models/custom-data-control-type.model';
import { CustomFieldDataTypeEnum } from '../models/custom-data-field-type.model';
import { YearService } from '../../../shared-components/year/year.service';
import { take } from 'rxjs/operators';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { SecurityService } from '../../../shared-components/security/security.service';
import { System } from '../../../shared-components/System';
import { cloneDeep } from 'lodash';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'custom-data-field',
    templateUrl: './custom-data-field.component.html',
    styleUrls: ['./custom-data-field.component.css']
})
export class CustomDataFieldComponent implements OnInit, OnDestroy {

    // private _id: number;
    // @Input() set id(value: number) {
    //     this._id = value;
    //     this.getFieldMetadata();
    // }
    // get id(): number {
    //     return this._id;
    // }

    private _fieldName: string;
    @Input() set fieldName(value: string) {
        this._fieldName = value;
        if (this.initialized) {
            this.getFieldMetadata();
        }
    }
    get fieldName(): string {
        return this._fieldName;
    }

    private _label: string;
    get label(): string {
        return this._label;
    }
    @Input() set label(value: string) {
        this._label = value;
        if (this.field) {
            this.field.DisplayName = value;
        }
    }

    private _controlTypeID: number;
    get controlTypeID(): number {
        return this._controlTypeID;
    }
    @Input() set controlTypeID(value: number) {
        this._controlTypeID = value;
        if (this.field) {
            this.field.ControlTypeID = value;
            if (this.field.ControlTypeID == this.controlTypes.RadioButtons) {
                this.setUpRadioButtons();
            }
        }
    }

    private _readOnly: boolean;
    get readOnly(): boolean {
        return this._readOnly;
    }
    @Input() set readOnly(value: boolean) {
        this._readOnly = value;
        if (this.field) {
            if (value == true) {
                this.field.ReadOnly = value;
            }
            else {
                const originalField = this.customizationFrameworkService.customDataFields.find(o => o.ID == this.field.ID);
                if (originalField) {
                    this.field.ReadOnly = originalField.ReadOnly;
                }
            }
            this.setReadWriteAccess();
        }
    }

    private _required: boolean;
    get required(): boolean {
        return this._required;
    }
    @Input() set required(value: boolean) {
        this._required = value;
        if (this.field) {
            if (value == true) {
                this.field.IsRequired = value;
            }
            else {
                const originalField = this.customizationFrameworkService.customDataFields.find(o => o.ID == this.field.ID);
                if (originalField) {
                    this.field.IsRequired = originalField.IsRequired;
                }
            }
        }
    }

    private _value: any;
    get value(): any {
        return this._value;
    }
    @Input() set value(val: any) {
        if (this.transformDataType(val) != this._value) {
            this._value = this.transformDataType(val);
            if (this.field) {
                if (this.field.DataTypeID == CustomFieldDataTypeEnum.Telephone) {
                    this.setTelephoneDisplayValue();
                }
                else if (this.field.DataTypeID == CustomFieldDataTypeEnum.YesNo && (typeof val) == 'string') {
                    this._value = val == 'true';
                }
                if (this.persistDataInMemory) {
                    if (this.field.IsDataDef && this.field.Options && this.field.Options.length > 0 && !this.field.Options.find(o => o.Id == val)) {
                        // invalid selection
                        this._value = null;
                    }
                    this.persistValue();
                }
            }
        }
    }


    private _masterId: number;
    get masterId(): number {
        return this._masterId;
    }
    @Input() set masterId(value: number) {
        if (this.initialized) {
            this.customizationFrameworkService.customFieldData.forEach(f => {
                if (f.CustomFieldID == this.field.ID && f.SiteYearId == this.yearService.defaultYear.SiteYearId && f.MasterId == this._masterId) {
                    f.MasterId = value;
                }
            });
        }
        this._masterId = value;
    }

    private _allowControlToHandleOwnData: boolean;
    public get allowControlToHandleOwnData(): boolean {
    return this._allowControlToHandleOwnData;
    }
    @Input() public set allowControlToHandleOwnData(value: boolean) {
        this._allowControlToHandleOwnData = value;
        if (this.initialized) {
            this.persistValue();
        }
    }

    @Input() pageIndex: number;
    @Input() width: string;
    @Input() hideLabel: boolean;
    @Input() hintLabel: string;
    @Input() noteRows: number;
    @Input() persistDataInMemory: boolean;
    @Input() alwaysShowControl: boolean;

    @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

    field: CSTField;
    controlTypes = CustomFieldControlTypeEnum;
    dataTypes = CustomFieldDataTypeEnum;
    subscriptions: Subscription[] = [];
    labels: string[] = [];
    values: string[] = [];
    ids: string[] = [];
    userCanView = true;
    userCanEdit = true;
    parentFieldValue: number;
    phoneMask = System.phoneTextMask;
    telephoneDisplayValue: string;
    initialized = false;
    metaDataRetrieved = false;
    timeControl: ElementRef;
    localDateValue: Date;
    localTimeValue: string;

    private _control: ElementRef;
    @ViewChild('control', { read: ElementRef }) set control(value: ElementRef) {
        this._control = value;
    }
    get control(): ElementRef {
        if (this.field.ControlTypeID == this.controlTypes.Time || this.field.ControlTypeID == this.controlTypes.Date || this.field.ControlTypeID == this.controlTypes.DateTime) {
            return this.timeControl;
        }
        else {
           return this._control;
        }
    }

    constructor(
        private customizationFrameworkService: CustomizationFrameworkService,
        private yearService: YearService,
        private securityService: SecurityService
    ) {
        const x = this.masterId;
    }

    ngOnInit() {
        this.getFieldMetadata();

        this.subscriptions.push(this.customizationFrameworkService.observablesSaveCustomFieldsTrigger.subscribe(o => {
            this.save();
        }));

        this.subscriptions.push(this.customizationFrameworkService.observableCustomDataFieldValueChangedStream$.subscribe(parentField => {
            if (this.pageIndex == parentField.PageIndex && this.field.ParentFieldID == parentField.ID && this.field.IsDataDef && this.field.LookupENUM) {
                this.getLookups();
            }
        }));

        this.subscriptions.push(this.securityService.observablePermissionStream$.subscribe(o => {
            if (this.field) {
               this.checkFieldPermissions();
            }
        }));

        this.subscriptions.push(this.customizationFrameworkService.observableobservableFieldMetaDataRetrievedStream$.subscribe(o => {
            if (!this.metaDataRetrieved) {
                this.getFieldMetadata();
            }
        }));


        this.initialized = true;
    }

    ngOnDestroy() { }

    getFieldMetadata() {
        if (this.fieldName) {
            const field = this.customizationFrameworkService.customDataFields.find(o => o.FieldName == this.fieldName);
            if (field) {
                this.metaDataRetrieved = true;
                this.setUpControl(field);
            }
        }
    }

    setUpControl(field: CSTField) {
        if (!field) {
            field = new CSTField();
        }
        const tmpField = cloneDeep(field);
        tmpField.PageIndex = this.pageIndex;
        if (this.label) {
            tmpField.DisplayName = this.label;
        }
        if (this.controlTypeID) {
            tmpField.ControlTypeID = this.controlTypeID;
        }
        if (this.readOnly) {
            tmpField.ReadOnly = true;
        }
        if (this.required) {
            tmpField.IsRequired = true;
        }
        this.field = tmpField;
        this.checkFieldPermissions();
        if (this.field.IsDataDef && this.field.LookupENUM) {
            this.getLookups();
        }
        if (this.userCanView) {
            this.getValue();
        }
        if (this.field.DataTypeID == CustomFieldDataTypeEnum.Telephone && this.value) {
            this.setTelephoneDisplayValue();
        }
    }

    getLookups() {
        if (!this.field.Options || this.field.Options.length == 0 || this.field.ParentFieldID > 0) {
            this.subscriptions.push(this.customizationFrameworkService.getDataDefinition(this.field.LookupENUM, this.yearService.defaultYear.Id, this.yearService.defaultYear.SiteYearId, this.parentFieldValue).pipe(take(1)).subscribe(options => {
                if (options) {
                    this.field.Options = options;
                    if (this.allowControlToHandleOwnData && this.persistDataInMemory && this.field.IsDataDef && this.field.Options && this.field.Options.length > 0 && !this.field.Options.find(o => o.Id == this.value)) {
                        // invalid selection
                        this._value = null;
                        this.persistValue();
                    }
                    const serviceField = this.customizationFrameworkService.customDataFields.find(o => o.FieldName == this.field.FieldName);
                    if (serviceField) {
                        serviceField.Options = options;
                    }
                    if (this.field.ControlTypeID == this.controlTypes.RadioButtons) {
                        this.setUpRadioButtons();
                    }
                }
                if (options.find(o => o.Id == this.value) == null) {
                    this.value = null;
                }
            }));
        }
        else {
            if (this.field.ControlTypeID == this.controlTypes.RadioButtons) {
                this.setUpRadioButtons();
            }
        }
    }

    checkFieldPermissions() {
        this.userCanView = this.customizationFrameworkService.userCanViewField(this.field, !this.readOnly, this.allowControlToHandleOwnData);
        this.userCanEdit = this.customizationFrameworkService.userCanEditField(this.field, !this.readOnly, this.allowControlToHandleOwnData);
        this.setReadWriteAccess();
    }

    setReadWriteAccess() {
        if (!this.userCanEdit || this.readOnly) {
            this.field.ReadOnly = true;
        }
        else {
            const originalField = this.customizationFrameworkService.customDataFields.find(o => o.ID == this.field.ID);
            if (!originalField.ReadOnly) {
                this.field.ReadOnly = false;
            }
        }
        if (this.initialized) {
            this.persistValue();
        }
    }

    getValue() {
        if (!this.value) {
            const dataObj = this.getCustomFieldDataObject();
            if (dataObj) {
                this.value = this.transformDataType(dataObj.Value);
                // this.valueChange.emit(this.value); -- this breaks the unsaved changes guard in Reg/Enroll
            }
        }
    }

    transformDataType(val: any): any {
        if (this.field && val) {
            if (this.field.DataTypeID == CustomFieldDataTypeEnum.Date || this.field.DataTypeID == CustomFieldDataTypeEnum.Datetime) {
                return new Date(val);
            }
            else if (this.field.DataTypeID == CustomFieldDataTypeEnum.Decimal || this.field.DataTypeID == CustomFieldDataTypeEnum.Integer) {
                return Number(val);
            }
            else {
                return val;
            }
        }
        else {
            return val;
        }
    }

    getCustomFieldDataObject(): CustomFieldDataObject {
        return this.customizationFrameworkService.customFieldData.find(o => o.CustomFieldID == this.field.ID && o.MasterId == this.masterId && o.SiteYearId == this.yearService.defaultYear.SiteYearId);
    }

    persistValue() {
        if (this.customizationFrameworkService.userCanEditField(this.field, !this.readOnly, this.allowControlToHandleOwnData) && this.persistDataInMemory && this.allowControlToHandleOwnData) {
            let dataObj = this.getCustomFieldDataObject();
            if (!dataObj) {
                if (this.pageIndex) {
                    dataObj = new CustomFieldDataObject();
                    dataObj.CustomFieldID = this.field.ID;
                    dataObj.MasterId = this.masterId;
                    dataObj.SiteYearId = this.yearService.defaultYear.SiteYearId;
                    dataObj.Value = this.value;
                    dataObj.ObjectID = this.field.ObjectID;
                    this.customizationFrameworkService.customFieldData.push(dataObj);
                }
            }
            else {
                dataObj.Value = this.value;
            }
        }
    }

    setUpRadioButtons() {
        if (this.field && this.field.Options) {
            this.labels = this.field.Options.map(o => o.Description);
            this.values = this.field.Options.map(o => o.Id.toString());
            this.ids = this.field.Options.map(o => 'rbField' + this.field.ID + '_' + o.Id);
        }
    }

    valueChangeHandler() {
        this.persistValue();
        this.valueChange.emit(this.value);
        this.customizationFrameworkService.customDataFieldValueChanged(this.field);
    }

    telephoneValueChanged() {
        let value = '';
        if (this.telephoneDisplayValue) {
            for (let i = 0; i < this.telephoneDisplayValue.length; i++) {
                if (this.telephoneDisplayValue[i] && this.telephoneDisplayValue[i] != ' ' && !isNaN(Number(this.telephoneDisplayValue[i]))) {
                    value += this.telephoneDisplayValue[i];
                }
            }
        }
        this._value = value;
        this.valueChangeHandler();
    }

    retrieveValueFromDB() {
        const dataObj = this.getCustomFieldDataObject();
        if (dataObj && dataObj.Value != null) {
            this.value = this.transformDataType(dataObj.Value);
        }
        else {
            if (this.masterId && this.allowControlToHandleOwnData) {
                this.customizationFrameworkService.getCustomDataFieldValue(this.field.ID, this.masterId, this.yearService.defaultYear.SiteYearId).pipe(take(1)).subscribe(val => {
                    this.value = this.transformDataType(val);
                    this.persistValue();
                });
            }
        }
    }

    validate(): ErrorList[] {
        return this.customizationFrameworkService.validateCustomField(this.field, this.value, this.control);
    }

    save(): ErrorList[] {
        const errors = this.validate();
        if (errors.length == 0 && !this.field.ReadOnly && this.allowControlToHandleOwnData && !this.persistDataInMemory && this.value != null) {
            this.customizationFrameworkService.updateCustomDataFieldValue(this.field.ID, this.masterId, this.value ? this.value.toString() : '', this.yearService.defaultYear.SiteYearId).pipe(take(1)).subscribe(result => {
                const success = result;
            });
        }
        return errors;
    }

    dateValueChanged(newDate: any) {
        this.localDateValue = newDate;
        this._value = this.concatDateAndTime();
        this.valueChangeHandler();
    }

    timeValueChange(time: string) {
        this.localTimeValue = time;
        this._value = this.concatDateAndTime();
        this.valueChangeHandler();
    }

    concatDateAndTime(): Date {
        const dt = new Date(this.localDateValue);
        if (dt && this.localTimeValue) {
            const timeParts = this.localTimeValue.split(':');
            if (timeParts.length == 2) {
                let hours = parseInt(timeParts[0].trim(), 10);
                let ampm = '';
                const minParts = timeParts[1].trim().split(' ');
                if (minParts.length > 0) {
                    const minutes = parseInt(minParts[0].trim(), 10);
                    if (minParts.length > 1) {
                        ampm = minParts[1].trim();
                    }
                    if (ampm.toLowerCase() == 'pm') {
                        hours += 12;
                    }
                    dt.setHours(hours);
                    dt.setMinutes(minutes);
                }
            }
        }
        return dt;
    }

    setLocalDateTime() {
        if (this.field.ControlTypeID == this.controlTypes.DateTime) {
            this.localDateValue = cloneDeep(this.value);
            this.localTimeValue = '';
            if (this.value) {
                let hours = (this.value as Date).getHours();
                const minutes = (this.value as Date).getMinutes();
                if (hours && minutes) {
                    let ampm = 'am';
                    let timeString = '';
                    if (hours < 10) {
                        timeString += '0';
                    }
                    else if (hours > 12) {
                        hours = hours - 12;
                        ampm = 'pm';
                    }
                    timeString += hours.toString();
                    timeString += ':';
                    if (minutes < 10) {
                        timeString += '0';
                    }
                    timeString += minutes.toString();
                    timeString += ' ';
                    timeString += ampm;
                    this.localTimeValue = timeString;
                }
            }
        }
    }

    setTelephoneDisplayValue() {
        if (this.field && this.field.DataTypeID == CustomFieldDataTypeEnum.Telephone) {
            let displayVal = '';
            if (this.value && !isNaN(this.value)) {
                let charLimit = 10;
                if (this.value.toString().length < 10) {
                    charLimit = this.value.toString().length;
                }
                for (let i = 0; i < charLimit; i++) {
                    if (i == 0) {
                        displayVal += '(';
                    }
                    displayVal += this.value.toString()[i];
                    if (i == 2) {
                        displayVal += ')';
                    }
                    else if (i == 5) {
                        displayVal += '-';
                    }
                }
            }
            this.telephoneDisplayValue = displayVal;
        }
    }

}
